import { transformConstants } from '../helpers';

const commonEventConstants = transformConstants(['MOKAPOS_INGREDIENT_LIBRARY_CREATE_SFI_FAILED']);

export { commonEventConstants };
